<template>
  <select-dict
    v-model="doorType"
    :selectList="doorTypes"
    :select-first-item="true"
    :disabled="isDivider"
  />
</template>

<script setup lang="ts">
import { computed, defineModel, watch } from "vue";

import SelectDict from "@/components/UI/SelectDict.vue";

import { useDictStore } from "@/stores/dictStore";
import { usePartitionStore } from "@/stores/new/partition.store";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { useMountsStore } from "@/stores/new/mounts.store";
import { useDoorsStore } from "@/stores/new/doors.store";

import { DoorPredicates } from "@/app/predicates";
import { DoorNoneCode } from "@/app/constants";

const doorType = defineModel<string>();

const estimateStore = useNewEstimateStore();
const dictStore = useDictStore();
const partitionStore = usePartitionStore();
const mountsStore = useMountsStore();
const doorsStore = useDoorsStore();

const activePartition = computed(() => partitionStore.activePartitions);
const installedSystemCode = computed(
  () => estimateStore.estimate.installedSystemCode,
);
const isDivider = computed(() => activePartition.value?.isDivider());

const doorTypes = computed(() => {
  // todo костыль, чтобы не добавлять ко всем типам дверей все типы партишн кроме dr-none, вернем руками dr-none
  if (activePartition.value?.isDivider()) {
    // divider
    return dictStore
      .getDoorTypes(installedSystemCode.value)
      .filter((item) => DoorPredicates.isDoorNone(item.code));
  }

  return dictStore.getDoorTypes(installedSystemCode.value);
});

const removeDoor = (currentDoor) => {
  if (currentDoor === DoorNoneCode) {
    // remove door from activePartition
    const activeDoorId = activePartition.value?.getActiveDoor()?.id;
    activePartition.value?.removeComponent(activeDoorId, "door");
    // remove door from doorStore
    doorsStore.$reset();
  }
};

watch(
  () => doorType.value,
  (currentDoor) => {
    mountsStore.$reset();
    removeDoor(currentDoor);
  },
);
</script>

<style lang="scss" scoped></style>
